import Sticky from 'sticky-js'

export default {
  init () {
    // console.log('single-documents')
    new Sticky('.single-document-header-downloads')
    /* $('.single-document-documents').append($('.single-document-content .block-documents')) */
  }
}
